<template>
  <v-dialog fullscreen value="true" transition="none">
    <v-container fill-height text-center>
      <v-row>
        <v-col>
          <v-slide-y-transition>
            <v-progress-circular
              :size="150"
              :width="6"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-slide-y-transition>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "Loading",
  beforeCreate() {
    const home = this.$store.dispatch("config/home");
    const user = this.$store.dispatch("user/user");
    Promise.all([home, user])
      .then(values => {
        this.$store.commit("config/home", values[0].data);
        this.$store.commit("user/user", values[1].data);
        this.$router.push({ name: this.$route.params.intent_route });
      })
      .catch(() => {
        this.$router.push("/");
      });
  }
};
</script>

<style scoped></style>
